import React, {useState, Suspense} from 'react';
import { Link , useLocation, useHistory } from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import Breadcrumb from 'layouts/admin/Breadcrumb';
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import CommonUtil from 'utils/CommonUtil';
import UISunEditor from "components/wysiwygeditor/UISunEditor";
import UI from "components/UI";
import TbComFile from "domain/main/com/file/TbComFile";
import TbComFileMapngDetail from "../../../../domain/main/com/file/mapng/TbComFileMapngDetail";
import UIUtils from "utils/UIUtils";
import PageLoading from "../../../../components/loading";

function ContentsContainer() {
	const history = useHistory();
	const location = useLocation();
	const receivedData = (location.state as any)?.data;
	const dmdNo = receivedData?.DEMAND_NO;
	const [demandDetail, setDemandDetail] = useState<any>([]);

	// 파일
	const [fileId,setFileId] = useState('관리자');
	const [fileInfoList, setFileInfoList] = React.useState<any[]>([]);
	const [loadFinish,setLoadFinish] = useState(false);

	//파일정보 선언
	const [dmdFileValue] = useState(new TbComFile());
	const [thumbFileValue] = useState(new TbComFile());

	//초기 데이터 설정
	let data = {};
	let param = {};

	// 상세조회
	async function getRead() {

		const response:any = await CommonUtil.execute({
			url: "adm_1701",
			data: {DEMAND_NO: dmdNo}
		}).then((response: any) => {
			const result = response;
			setDemandDetail(response);
			setFileId(response.FILE_ID);

			// 파일이 있을경우
			let fileList = result.FILE_INFO;
			if(fileList.length > 0){
				for(let i=0; i<fileList.length; i++){

					if(fileList[i].FILE_GB == 'FILE'){
						let fileInfo = fileList[i];

						//파일등록 정보
						const fileDetail = new TbComFileMapngDetail();
						fileDetail.setDwldId(fileInfo.DWLD_ID);
						fileDetail.setFileDetailId(fileInfo.FILE_DETAIL_ID);
						fileDetail.setFilePolicy(fileInfo.FILE_POLICY);
						fileDetail.setFileRpstr(fileInfo.FILE_RPSTR);
						fileDetail.setStrePath(fileInfo.STRE_PATH);
						fileDetail.setStreFileNm(fileInfo.STRE_FILE_NM);
						fileDetail.setOrginlFileNm(fileInfo.ORGINL_FILE_NM);
						fileDetail.setFileExtsn(fileInfo.FILE_EXTSN);
						fileDetail.setFileSize(fileInfo.FILE_SIZE);
						fileDetail.setRegistPsnNm(fileInfo.REGIST_PSN_NM);
						fileDetail.setRegistDt(fileInfo.REGIST_DT);
						dmdFileValue.putTbComFileMapngDetailList(fileDetail);
					} else {
						let thumbInfo = fileList[i];

						//파일등록 정보
						const fileDetail = new TbComFileMapngDetail();
						fileDetail.setDwldId(thumbInfo.DWLD_ID);
						fileDetail.setFileDetailId(thumbInfo.FILE_DETAIL_ID);
						fileDetail.setFilePolicy(thumbInfo.FILE_POLICY);
						fileDetail.setFileRpstr(thumbInfo.FILE_RPSTR);
						fileDetail.setStrePath(thumbInfo.STRE_PATH);
						fileDetail.setStreFileNm(thumbInfo.STRE_FILE_NM);
						fileDetail.setOrginlFileNm(thumbInfo.ORGINL_FILE_NM);
						fileDetail.setFileExtsn(thumbInfo.FILE_EXTSN);
						fileDetail.setFileSize(thumbInfo.FILE_SIZE);
						fileDetail.setRegistPsnNm(thumbInfo.REGIST_PSN_NM);
						fileDetail.setRegistDt(thumbInfo.REGIST_DT);
						thumbFileValue.putTbComFileMapngDetailList(fileDetail);

					}

				}

			}
			setLoadFinish(true);

		}).catch((error) => {
			CommonUtil.showAxiosError(error);
			return;
		});

	}

	// 목록으로 이동
	async function onClickList(event) {
		event.preventDefault();
		let dataToSend = {};
		// 다른 페이지로 이동하면서 데이터 전달
		history.push({
			pathname: './adm1700',
			state: { data: dataToSend }
		});
	};

	// 수정
	async function onClickEdit(event) {
		event.preventDefault();
		let dataToSend = {DEMAND_NO : dmdNo.replaceAll('-','')};
		// 다른 페이지로 이동하면서 데이터 전달
		history.push({
			pathname: './adm1703',
			state: { data: dataToSend }
		});
	};

	// 삭제
	async function onClickDelete(event) {
		event.preventDefault();

		if(await UIUtils.confirm('삭제하시겠습니까?')){
			param = {DEMAND_NO : dmdNo.replaceAll('-',''),
					FILE_ID : fileId,
					}
			const response:any = await CommonUtil.execute({
				url:"adm_1701_d001",
				data: param
			});
			UIUtils.alert("삭제되었습니다.").then();

			// 삭제 후 목록으로 이동
			history.push({
				pathname: './adm1700',
			});
		}

	};

	React.useEffect(() => {

		getRead();

	}, []);//effect

	if(!loadFinish)
		return (
			<PageLoading />
		)
	else
	return (
		<PageContainer>
			<LayoutAside />
			<div className='fww-con'>
				<Breadcrumb gnbIdx={0} lnbD1Idx={6}  lnbD2Idx={1}/>
				<main className="fww-main">
					<h1 className="tx tx-hd2">수요조사 안내문 상세</h1>

					<form className="fo fo-col3" name="" action="" method="">
						<div className="inner">
							<div className="fo-item">
								<p className="fo-key">등록자</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={demandDetail.PERSON_NM} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">등록일시</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={demandDetail.REG_DATE} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">구분번호</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={demandDetail.DEMAND_NO} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">모집기간</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={demandDetail.DATE} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">상태</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={demandDetail.STS_CD == 'Y' ? '모집중' : '모집완료'} placeholder={''} readOnly={true} />
								</div>
							</div>
						</div>
					</form>

					<div className="ta-view h100p mt30">
						<UISunEditor value={demandDetail.CONT} displayOnly={true} readOnly={true} />
					</div>

					<div className="info-bottom">
						<p className="desc">
							{demandDetail.TITLE} 공고문을 확인하고, 위와 같이 신청서를 제출하였습니다.
						</p>
						<p className="who">
							대·중소기업·농어업협력재단 사무총장 귀하
						</p>
					</div>

					<h3 className="section-title mb15">첨부파일</h3>
					<div>
						<Suspense fallback={<PageLoading/>}>
							<UI.FileDownload value={dmdFileValue} attrs={{ImgPreView: '1',}}/>
						</Suspense>
					</div>
					<br/>

					<div className="hz-root hz-right hz-gap5">
						<Button color="gray-o" size="sm" onClick={onClickDelete}>삭제</Button>
						<Button color="pri-o" size="sm" onClick={onClickEdit}>수정</Button>
						<Button color="gray-o" size="sm" onClick={onClickList}>목록</Button>
					</div>


				</main>
			</div>
		</PageContainer>
	);
}
export default ContentsContainer;